<script setup lang="ts">
  import type { SectionLine, SectionLineUploadCollection } from '@/stores/type/sectionLine.type'
  import { useEventsBus } from '@haskoning/vue-component-library'

  const sectionLineUploadCollectionsStore = useSectionLineUploadCollectionsStore()
  const sectionLinesStore = useSectionLinesStore()
  const { items: sectionLineUploadCollections } = storeToRefs(sectionLineUploadCollectionsStore)

  const { visualiseItem: visualiseSectionLine } = storeToRefs(sectionLinesStore)

  const { emit: busEmit } = useEventsBus()
  const openedIDs = ref<number[]>([])
  onMounted(() => {
    if (sectionLineUploadCollections.value.length > 0) {
      openedIDs.value = [sectionLineUploadCollections.value[0].id]
    }
  })

  const sortedSectionLines = (item: SectionLineUploadCollection) => {
    return item.sectionline_set.features.sort((a: SectionLine, b: SectionLine) => a.id - b.id)
  }
  const emitItem = (item: SectionLine) => {
    sectionLinesStore.toggleVisualiseItem(item)
    busEmit('fly-to-polyline', item)
  }
</script>
<template>
  <v-list class="pt-0 overflow-y-auto" v-model:opened="openedIDs" style="max-height: 87%">
    <v-list-group
      v-for="item in sectionLineUploadCollections"
      :key="item.id"
      :value="item.id"
      subgroup
    >
      <template v-slot:activator="{ props }">
        <v-list-item
          :nav="true"
          density="compact"
          :v-ripple="true"
          class="w-100 py-0 mb-0 mt-0 list-item border-b rounded-0"
          v-bind="props"
        >
          <v-list-item-title class="text-h6 font-weight-bold">
            {{ item.name }}
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-for="profile in sortedSectionLines(item)" :key="profile.id">
        <v-list-item
          :nav="true"
          class="list-item border-b rounded-0 mb-0 mt-0"
          density="compact"
          :class="{ 'selected-item': visualiseSectionLine === profile }"
          @click.stop.prevent="emitItem(profile)"
        >
          <v-list-item-title class="text-primary h-100 my-auto ml-4">
            {{ profile.properties.section_title }}
            {{ profile.properties.section_code && `(${profile.properties.section_code})` }}
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="!sortedSectionLines(item).length">
        <v-list-item density="compact" class="ml-5 text-subtitle-1">
          No Data available.
        </v-list-item>
      </template>
    </v-list-group>
  </v-list>
</template>

<style scoped>
  div :deep(.v-list-item__prepend) {
    max-width: 24px;
  }

  :deep(.v-data-table-footer) {
    display: none;
  }

  :deep(.v-list .v-list-item--nav:not(:only-child)) {
    margin-bottom: 0 !important;
  }

  :deep(.v-list-group__items .v-list-item) {
    /* overwrites vuetify's default padding-inline-start: calc(16px + var(--indent-padding))!important;*/
    padding-inline-start: 10px !important;
  }

  .sub-group-item :deep(.v-list-item__append) {
    padding-right: 8px;
  }

  .selected-item {
    background-color: #f4fcff;
  }

  .list-item:hover {
    background-color: #f4fcff;
  }

  :deep(.v-table__wrapper) table tbody tr:hover {
    background-color: #f4fcff;
  }
</style>
